import { Inject, Injectable, Injector } from "@angular/core";
import { SpecialInstructions } from "@core/model/special-instructions";
import { Observable } from "rxjs";
import { ApiServiceBase } from "./api-service-base";
import { API_BASE_URL } from "./config.service";

@Injectable({
    providedIn: 'root'
})
export class SpecialInstructionsService extends ApiServiceBase {
  constructor(
      injector: Injector,
      @Inject(API_BASE_URL) private apiBaseUrl: string
    ) {
      super('SpecialInstructionsService', injector);
    }

    getSpecialInstructions(tenantId: string, authorizationId: string): Observable<SpecialInstructions> {
      const url = `${this.apiBaseUrl}SpecialInstructions/Get/${tenantId}/${authorizationId}`;

      return this.httpUtility.get(url);
    }

    createSpecialInstructions(tenantId: string, specialInstructions: SpecialInstructions): Observable<SpecialInstructions> {
      const url = `${this.apiBaseUrl}SpecialInstructions/Create/${tenantId}`;

      return this.httpUtility.post(url, specialInstructions);
    }

    updateSpecialInstructions(tenantId: string, specialInstructions: SpecialInstructions): Observable<SpecialInstructions> {
      const url = `${this.apiBaseUrl}SpecialInstructions/Update/${tenantId}`;

      return this.httpUtility.put(url, specialInstructions);
    }
}
